export default {
  title: 'Tools',
  login: 'Create an account to save your data!'
};
